// extracted by mini-css-extract-plugin
module.exports = {"load-more__relative-wrapper":"load-more_load-more__relative-wrapper__fT1sx","load-more__trigger":"load-more_load-more__trigger__9uIOm"};